// Strings locales del módulo M9 · Dashboard (docs/08 Ola C).
export const dashboardI18n = {
  title: "Dashboard",
  description: "Estado de la instancia en tiempo real: sesiones, accesos y salud de nodos.",
  cards: {
    activeUsers: "Usuarios activos",
    loginsPerMinute: "Logins por minuto",
    loginsSuccess: "Logins exitosos",
    loginsFailed: "Logins fallidos",
    requestsPerSecond: "Requests por segundo",
    nodesHealthy: "Nodos sanos",
    nodesTotal: "Nodos totales",
  },
  loadError: "No se pudieron cargar las métricas.",
} as const
